// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2803":"css/app.6832","4783":"css/admin-app.6832"}[chunkId] + ".css";
};